// extracted by mini-css-extract-plugin
export default {"toolbar":"Segments-toolbar-abbe","select":"Segments-select-fb76","id":"Segments-id-d2b8","scope":"Segments-scope-d9e2","flex":"Segments-flex-fe18"};